import { useEffect, useState, useRef } from "react"
import React from "react"
import {CSSTransition} from "react-transition-group"

// Tooltip needs a ref to the element of the wysiwyg block (parentCopy)
// this way it can be placed in the right spot

const ToolTip = ({parentCopy, tooltip, storyColor='white', }) => {
    const thisTooltip = useRef(null);
    const [tooltipVisible, setTooltipVisible] = useState(false);

    const handleClickIcon = () => {
      setTooltipVisible(!tooltipVisible);
    }
    const handleWindowClick = (e) => {
      if (e.target.closest('.tooltip') !== thisTooltip.current) {
        setTooltipVisible(false);
      }
    };

    const setToolTipCopyPosition = (thisTooltip, windowInnerWidth) => {
      const toolTipXPosition = thisTooltip.getBoundingClientRect().left;
      console.log(toolTipXPosition);
      console.log(thisTooltip);
      const tooltipContentEl = thisTooltip.querySelector('.tooltip--content');
      if (windowInnerWidth - toolTipXPosition < 350) {
        if (tooltipContentEl) {
          tooltipContentEl.style.left = -(tooltipContentEl.offsetWidth - (windowInnerWidth - toolTipXPosition) + 25) + 'px';
        }
      } else if (tooltipContentEl && toolTipXPosition < 26) {
        tooltipContentEl.style.left = '0px';
      }
    }

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setTooltipVisible(false);
      } else if (e.key === 'Enter') {
        setTooltipVisible(true);
      }
    }

    useEffect(() => {
        parentCopy.current.lastElementChild.appendChild(thisTooltip.current);

      if (thisTooltip.current && thisTooltip.current.querySelector('.tooltip--content')) {
        const windowInnerWidth = window.innerWidth;
        setToolTipCopyPosition(thisTooltip.current, windowInnerWidth);
      }

      window.addEventListener('resize', () => setTooltipVisible(false));
      window.addEventListener('click', (e) => handleWindowClick(e));
      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          setTooltipVisible(false);
        }
      });
      return () => {
        window.removeEventListener('resize', () => setTooltipVisible);
        window.removeEventListener('click', () => handleWindowClick);
        window.addEventListener('keydown', () => {});
      }
    }, [tooltipVisible]);

    return (
      <span className="tooltip" ref={thisTooltip} tabIndex={0} onKeyDown={handleKeyDown}>
        <span className={`tooltip--icon`} >
          <span className={tooltipVisible ? storyColor : ''} onClick={handleClickIcon}>i</span>
        </span>
        <CSSTransition in={tooltipVisible} timeout={300} classNames="tooltip--animation" unmountOnExit>
          <span>
            <span className="tooltip--arrow"></span>
            <span className="tooltip--content " dangerouslySetInnerHTML={{__html: tooltip}} />
          </span>
        </CSSTransition>
      </span>
    )
}

export default ToolTip;